<form (ngSubmit)="submit()" novalidate [formGroup]="form">
  <ion-list>
    <ion-item>
      <ion-label floating>
        @if (formErrors.has('card')) {
          <span color="danger"><br />{{formErrors.get('card')}}</span>
        }
      </ion-label>
      <ion-input formControlName="card" type="text" [placeholder]="cardPlaceHolder"></ion-input>
    </ion-item>
  </ion-list>

  <ion-list>
    <ion-item>
      <ion-label floating>
        @if (formErrors.has('cvn')) {
          <span color="danger"><br />{{formErrors.get('cvn')}}</span>
        }
      </ion-label>
      <ion-input formControlName="cvn" type="text" [placeholder]="cvcPlaceHolder"></ion-input>
    </ion-item>
  </ion-list>

  <div padding>
    <ion-button type="submit" [disabled]="!form.valid" ion-button color="primary" expand="block">
      {{ 'Account.AddExistingCard' | translate }}
    </ion-button>
  </div>
</form>